import { LoadingButton } from "@mui/lab";
import { Stack, TextField } from "@mui/material";
import { useSubscriptionTerminate } from "hooks/api/useSubscriptionTerminate";
import { useState } from "react";

export const TerminateForm = ({ subscriptionId }) => {
    const { terminate, isLoading } = useSubscriptionTerminate();
    const [terminateInput, setTerminateInput] = useState("");

    const isConfirmed = terminateInput.trim().toUpperCase() === "TERMINATE";

    const handleTermination = async () => {
        if (!isConfirmed) return;
        await terminate(subscriptionId);
    };

    return (
        <Stack direction="row" gap={2} p={2} alignItems="center">
            <TextField
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={(e) => setTerminateInput(e.target.value)}
                size="small"
                label="Type 'TERMINATE'"
                variant="standard"
                placeholder="TERMINATE"
                error={!isConfirmed && terminateInput.length > 0}
                helperText={
                    !isConfirmed && terminateInput.length > 0
                        ? "Input must match 'TERMINATE'"
                        : ""
                }
                sx={{
                    "& .MuiInputBase-root": {
                        color: isConfirmed ? "error.main" : undefined,
                    },
                }}
            />
            <LoadingButton
                loading={isLoading}
                onClick={handleTermination}
                size="small"
                color="error"
                variant="contained"
                disabled={!isConfirmed || isLoading}
                sx={{
                    px: "2rem",
                }}
            >
                Terminate
            </LoadingButton>
        </Stack>
    );
};

export default TerminateForm;
